<template>
  <!-- :dark="barColor !== 'rgba(69, 160, 73, 1), rgba(69, 160, 72, 1)'" -->
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(69, 160, 73, 1), rgba(69, 160, 72, 1)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    :src="barImage"
    :color="corPrimaria"
    mobile-breakpoint="960"
    app
    mini-variant-width="80"
    width="240"
    v-bind="$attrs"
  >
    <!-- <template v-slot:img="props">
      <v-img
        :gradient="`to bottom, ${barColor}`"
        v-bind="props"
      />
    </template> -->

    <!-- <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title class="text-uppercase font-weight-regular text-h3">
          <span class="logo-mini">{{ $t('ct') }}</span>
          <span class="logo-normal">{{ $t('tim') }}</span>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item> -->

    <!-- <v-divider class="mb-1" /> -->

    <!-- Profile Antigo -->
    <!-- <v-list
      dense
      nav
    >
      <base-item-group
        :item="profile"
      />
    </v-list> -->

    <!-- <v-list
      id="edtProfile"
      dense
      nav
    >
      <template v-for="(item, i) in computedProfile">
        <base-item-group
          v-if="item.children"
          :key="`group-${i}`"
          :item="item"
        />

        <base-item
          v-else
          :key="`item-${i}`"
          :item="item"
        />
      </template>
    </v-list> -->

    <v-divider class="mb-2" />

    <v-list
      expand
      nav
    >
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />

      <template v-for="(item, i) in computedItems">
        <base-item-group
          v-if="item.children"
          :key="`group-${i}`"
          :item="item"
        >
          <!--  -->
        </base-item-group>

        <base-item
          v-else
          :key="`item-${i}`"
          :item="item"
        />
      </template>

      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />
    </v-list>

    <!-- <div
      id="spanFooter"
      class="font-weight-light text-center align-bottom"
    >
      &copy; 2021, Magistech Sistemas (versão {{ versao }})
    </div> -->
    <template v-slot:append>
      <v-list>
        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title class="font-weight-light text-center">
              <span
                id="spanText"
                class="logo-normal"
              >&copy; 2022, Magistech Sistemas (versão {{ versao }})</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
  </v-navigation-drawer>
</template>

<script>
  // Utilities
  import {
    mapState,
  } from 'vuex'
  import Versao from '../../../../services/versao'

  export default {
    name: 'DashboardCoreDrawer',

    props: {
      expandOnHover: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      versao: '',
      nomeVersao: 'MagisVendasWeb',
      items: [
        {
          icon: 'mdi-view-dashboard',
          title: 'dashboard',
          to: '/dashboard',
        },
        {
          icon: 'mdi-shopping',
          title: 'lista-produtos',
          to: '/lista-produtos',
        },
        {
          icon: 'mdi-cart-arrow-down',
          title: 'cart',
          to: '/carrinho',
        },
        {
          icon: 'mdi-cart-arrow-right',
          title: 'finaliza-compra',
          to: '/finaliza-compra',
        },
        {
          icon: 'mdi-file-document-multiple',
          title: 'lista-pedido',
          to: '/lista-pedido',
        },
        // {
        //   icon: 'mdi-shopping',
        //   title: 'Lista Produtos Off-line',
        //   to: '/lista-produtos-offiline',
        // },
      ],
      corPrimaria: localStorage.corPrimaria,
      // profile: [
      //   {
      //     title: localStorage.nome + ' - Editar Perfil',
      //     to: '/editar-perfil',
      //   },
      // ],
      // titulo: '',
    }),

    computed: {
      ...mapState(['barColor', 'barImage']),
      drawer: {
        get () {
          return this.$store.state.drawer
        },
        set (val) {
          this.$store.commit('SET_DRAWER', val)
        },
      },

      computedItems () {
        return this.items.map(this.mapItem)
      },

      computedProfile () {
        return this.profile.map(this.mapProfile)
      },
      // profile () {
      //   return {
      //     avatar: true,
      //     group: '',
      //     title: localStorage.nome,
      //     children: [
      //       {
      //         to: 'editar-perfil',
      //         title: this.$t('edit-profile'),
      //       },
      //     ],
      //   }
      // },
    },

    watch: {
      '$vuetify.breakpoint.smAndDown' (val) {
        this.$emit('update:expandOnHover', !val)
      },
    },

    mounted () {
      this.titulo = localStorage.nome

      Versao.showVersion(localStorage.tokencontrato, this.nomeVersao).then(resposta => {
        if (resposta.data.status) {
          this.versao = resposta.data.versao
        } else {
          this.versao = null
        }
      }).catch(e => {
        if (e.message === 'Network Error') {
          this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
        }
      })
    },

    methods: {
      mapItem (item) {
        return {
          ...item,
          children: item.children ? item.children.map(this.mapItem) : undefined,
          title: this.$t(item.title),
        }
      },

      mapProfile (item) {
        return {
          ...item,
          children: item.children ? item.children.map(this.mapProfile) : undefined,
          title: this.$t(item.title),
        }
      },
    },
  }
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  #core-navigation-drawer
    &.v-navigation-drawer--mini-variant
      .v-list-item
        justify-content: flex-start !important

      .v-list-group--sub-group
        display: block !important

    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px

  #spanFooter
    margin-top: 17em
    align-items: flex-end
    color: white
    font-size:0.8em

  #spanText
    font-size: 11px
  // #edtProfile
  //   margin-top: 5rem

</style>
